import { Box, Button, Divider, Stack } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { FeatureContext } from '../../context/FeatureFlagContext';
import { usePermissions } from '../../hooks/usePermissions';

type Props = {
  submitDisabled?: boolean;
  onSubmit?: () => void;
  onBack?: () => void;
  onDirectSubmit?: () => void;
  visibilityFlag?: boolean;
  autoAssignmentElidgible?: boolean;
  showDirectSubmit?: boolean;
  submitDirectDisabled?: boolean;
  nextEnable?: boolean;
  handleDirectAssignment?: boolean;
  onNext?: () => void;
  orderAvailability?: boolean;
  autoAssignment?: boolean;
};

const AssignmentModalControls: React.FC<Props> = ({
  onSubmit,
  submitDisabled,
  onBack,
  onDirectSubmit,
  autoAssignmentElidgible,
  visibilityFlag,
  showDirectSubmit,
  submitDirectDisabled,
  nextEnable,
  handleDirectAssignment,
  orderAvailability,
  autoAssignment,
  onNext,
}) => {
  const featureFlagCtx = useContext(FeatureContext); // not using feature flag as of now
  const { hasPermissions, getRole } = usePermissions();

  const getControlVisibility: any = () => {
    if (orderAvailability) {
      if (hasPermissions(['PERFORM_DIRECT_APPROVE_ASSIGNMENT'])) {
        return {
          assignButtonFlag: true,
          requestButtonFlag: false,
        };
      }
      if (hasPermissions(['PERFORM_LIMITED_DIRECT_ASSIGNMENT'])) {
        if (autoAssignmentElidgible) {
          return {
            assignButtonFlag: true,
            requestButtonFlag: false,
          };
        }
        return {
          assignButtonFlag: false,
          requestButtonFlag: true,
        };
      }
      if (hasPermissions(['PERFORM_REQUEST_ONLY'])) {
        return {
          assignButtonFlag: false,
          requestButtonFlag: true,
        };
      }
      return {
        assignButtonFlag: false,
        requestButtonFlag: false,
      };
    }
    return {
      assignButtonFlag: false,
      requestButtonFlag: true,
    };
  };
  return (
    <Box>
      <Box display="flex" justifyContent="flex-end">
        <Stack direction="row" spacing={2} className="check">
          {visibilityFlag && (
            <Button variant="outlined" onClick={onBack}>
              Back
            </Button>
          )}
          {!visibilityFlag && (
            <Button variant="outlined" onClick={onBack}>
              Cancel
            </Button>
          )}

          {visibilityFlag && getControlVisibility().assignButtonFlag && (
            <Button variant="contained" onClick={onDirectSubmit}>
              Assign
            </Button>
          )}
          {visibilityFlag && getControlVisibility().requestButtonFlag && (
            <Button variant="contained" disabled={!!submitDisabled} onClick={onSubmit}>
              Request
            </Button>
          )}

          {!visibilityFlag && (
            <Button variant="contained" disabled={nextEnable} onClick={onNext}>
              Next
            </Button>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default AssignmentModalControls;
